export default "/fonts/vendor/@fontsource/inter/files/inter-greek-ext-400-normal.woff2?18e3b17c2aceabafdd3ca6030e0a7dc3";